module.exports = __webpack_public_path__ + "static/media/settings.983a1c7d.svg";